
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[articleSlug]",
      function () {
        return require("private-next-pages/article/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[articleSlug]"])
      });
    }
  